import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import { Translation } from 'react-i18next'
import NavIcon from './navicon.component'
import FontAwesome from 'react-fontawesome'
import userManager from '../../utils/PHZUserManager'
import Language from '../lang.component'
import mobileView from '../../utils/mobile.utils'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core'
import ReleaseInfoContainer from '../../containers/dashboard/releaseInfo.container'
import { connect } from 'react-redux'
import { showInvoiceFormDialog } from '../../actions'

/**
 * Bootstrap styled navigation bar
 *
 * @author Pragya Gupta
 */
const brandLogo = '../../images/invosy_logo.png'

class Navigation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false
    }
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  toggleMenu() {
    this.setState({ menu: !this.state.menu })
  }
  _createNavIcons = (navItems) => (
    <ul className={mobileView ? 'nav' : 'nav nav-pills pull-right'}>
      {navItems.map((navItem, iter) => (
        <li key={iter} className="nav-tab">
          {navItem.content === 'UUSI_LASKUT' ? (
            <NavLink
              className="dashboard-nav-linklist"
              to={navItem.url}
              style={{ padding: 0 }}
              onClick={() => {
                if (mobileView) {
                  this.toggleMenu()
                }
                this.props.showInvoiceFormDialog()
              }}
            >
              <NavIcon
                name={navItem.name}
                content={navItem.content}
                size="2x"
              />
            </NavLink>
          ) : (
            <NavLink
              className={(isActive) =>
                isActive ? 'dashboard-nav-icon' : 'dashboard-nav-linklist'
              }
              to={navItem.url}
              onClick={mobileView ? this.toggleMenu : null} //Hide menu panel when any item is clicked on mobile
              style={{ padding: 0 }}
            >
              <NavIcon
                name={navItem.name}
                content={navItem.content}
                size="2x"
              />
            </NavLink>
          )}
        </li>
      ))}
    </ul>
  )

  _handleLogout = (e) => {
    e.preventDefault()
    // removes the user data from sessionStorage
    userManager.removeUser()
  }

  _handleManualLogout = (e) => {
    e.preventDefault()
    this.props.handleManualLogout(e)
  }

  render() {
    let {
      user,
      navItems,
      showNotiDialog,
      getUserCompanyUpdateInfo,
      openCompanyNotificationDialog,
      closeCompanyNotificationDialog,
      notiIsNotRead,
      setReadCompanyUpdate
    } = this.props
    const show = this.state.menu ? 'showMenu' : 'hideMenu'
    return (
      <Translation>
        {(t) => {
          return (
            <div
              className="navbar navbar-default"
              id="top-navbar"
              style={{ marginBottom: '0px' }}
            >
              <div className="header-lined">
                <div className="container-fluid dashboard-header-emptytop" />
                {/* <div
                  className="container-fluid dashboard-header-top hide-mobile"
                  style={{ width: '60%' }}
                >
                  <ul className="nav nav-pills pull-right">
                    <li style={{ paddingRight: '60px' }}>
                      <NavLink
                        to="/dashboard/profile"
                        className={(isActive) =>
                          isActive ? 'dashboard-nav-icon' : undefined
                        }
                      >
                        {t('dashboard.asetu')}
                      </NavLink>
                    </li>
                    {user.data[5] == 1 ? (
                      <li>
                        <NavLink
                          to="/dashboard/admin"
                          className={(isActive) =>
                            isActive ? 'dashboard-nav-icon' : undefined
                          }
                        >
                          {t('dashboard.hallinta')}
                        </NavLink>
                      </li>
                    ) : null}
                  </ul>
                </div> */}
                <div className="container-fluid dashboard-header-top">
                  <ul
                    className="nav nav-pills pull-right"
                    style={{ paddingRight: '40px' }}
                  >
                    <li
                      onClick={() => {
                        getUserCompanyUpdateInfo()
                        openCompanyNotificationDialog()
                      }}
                    >
                      <a
                        style={{
                          color: notiIsNotRead.length > 0 ? '#F67131' : ''
                        }}
                      >
                        {' '}
                        <FontAwesome name="fa-solid fa-bell" />
                      </a>
                    </li>
                    <li className="hide-mobile">
                      <a
                        style={{
                          color: '#333333',
                          pointerEvents: 'none',
                          paddingRight: '30px'
                        }}
                      >
                        {user.data[1]}
                      </a>
                    </li>
                    <li>
                      <Language />
                    </li>
                    <li onClick={this._handleManualLogout}>
                      <Link to="/dashboard/login">
                        <FontAwesome name="unlock-alt" /> {t('logout.label')}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="container-fluid dashboard-header-bottom">
                <div className="dashboard-header-brand">
                  <Link to="/dashboard/main">
                    <img
                      className="navbar-brand dashboard-nav-brand"
                      src={brandLogo}
                      style={{
                        maxHeight: '5.5em',
                        maxWidth: mobileView ? '7em' : '11em',
                        objectFit: 'cover'
                      }}
                    />
                  </Link>
                  <button
                    className={
                      show === 'showMenu'
                        ? 'navbar-toggle open'
                        : 'navbar-toggle'
                    }
                    type="button"
                    onClick={this.toggleMenu}
                  >
                    <span className="icon-bar" />
                  </button>
                </div>
                {/* <div className="nav navbar-nav navbar-right dashboard-nav-left">
                  {this._createNavIcons(navItems)}
                </div> */}
                <div className={show}>{this._createNavIcons(navItems)}</div>
              </div>
              <Dialog open={showNotiDialog} fullWidth maxWidth="md">
                <DialogTitle
                  id="alert-dialog-title"
                  style={{ paddingBottom: 0 }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '100%'
                    }}
                  >
                    <span
                      style={{
                        fontSize: '20px',
                        textAlign: 'center',
                        color: '#000000'
                      }}
                    >
                      {t('dashboarComp.tiedo')}
                    </span>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <div className="panel panel-default">
                    <ReleaseInfoContainer />
                  </div>
                </DialogContent>
                <DialogActions style={{ padding: '0px 24px 24px' }}>
                  <Button
                    onClick={() => {
                      setReadCompanyUpdate(notiIsNotRead)
                      closeCompanyNotificationDialog()
                    }}
                    variant="outlined"
                    style={{ marginRight: 0 }}
                  >
                    {t('dashboardRelaseInfo.btn')}
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          )
        }}
      </Translation>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  showInvoiceFormDialog: () => dispatch(showInvoiceFormDialog())
})

export default connect(null, mapDispatchToProps)(Navigation)